import { useQuery, useMutation, useQueryClient } from 'react-query';
import axiosInstance from '../../config/axiosInstance';
import { UpsertProductInput } from '../../config/types/custom/TranslationInput';
import { ProductModel } from '../../config/types/models';
import { urls } from '../../config/urls';

export const useProductDetails = (id: number | string | undefined) => {
  return useQuery(
    ['product', id],
    (): Promise<ProductModel> =>
      axiosInstance
        .get(`${urls.product.details}/${id}`)
        .then((res) => res.data),
    {
      enabled: !!id,
    }
  );
};

export const useSaveProduct = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (data: UpsertProductInput) =>
      axiosInstance
        .post(`${urls.product.details}`, data)
        .then((res) => res.data),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(['product', data.id]);
      },
    }
  );
};
